import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/Slices/modalSlice';
import { fetchWorkspaces } from '../../redux/Slices/workspaceSlice';
import { fetchUser } from '../../redux/Slices/thunks';
import { config } from '../../config';
import './scss/StartTrialModal.scss';
import CircleCheckOutlined from '../icons/CircleCheckOutlined';
import { Close, Schedule, Error } from '../icons';

const StartTrialModal = ({ workspaceId, planType = 'Premium' }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleClose = () => {
        dispatch(closeModal());
    };

    const handleStartTrial = async () => {
        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${config.API_URI}/v1/billing/workspace/${workspaceId}/start-trial`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ planType })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to start trial');
            }

            // Success - refresh trial/subscription state without a jarring full
            // page reload (subscription is populated on the workspace; premium
            // flags come from the user).
            await Promise.all([
                dispatch(fetchWorkspaces({ useCache: false })),
                dispatch(fetchUser()),
            ]);
            handleClose();

        } catch (err) {
            setError(err.message || 'Something went wrong starting your trial. Please try again.');
            setLoading(false);
        }
    };

    const trialFeatures = planType === 'Premium' ? [
        'Unlimited collaborators',
        'Unlimited storage',
        'Pro verified badge',
        'Priority support',
        'Advanced checklists',
        'List colors',
        // 'Data export (JSON/CSV)',
        'Extended activity logs',
        'Performance insights'
    ] : [
        'Unlimited collaborators',
        'Unlimited storage',
        'Pro verified badge',
        'Advanced checklists',
        'List colors',
        'Saved searches',
        'Online status visibility'
    ];

    return (
        <div className="start-trial-modal">
            <div className="trial-modal-header">
                <h2>Start Your Free Trial</h2>
                <button className="close-button" onClick={handleClose}>
                    <Close size={24} />
                </button>
            </div>

            <div className="trial-modal-body">
                <div className="trial-plan-info">
                    <h3>{planType} Plan</h3>
                    <div className="trial-duration">
                        <Schedule size={20} color='var(--brand-color)' />
                        <span>14 days free trial</span>
                    </div>
                    {/* <p className="trial-description">
                        No credit card required. Cancel anytime during the trial period.
                    </p> */}
                </div>

                <div className="trial-features">
                    <h4>What's included:</h4>
                    <ul>
                        {trialFeatures.map((feature, index) => (
                            <li key={index}>
                                 <CircleCheckOutlined size={20} color='var(--success-color)' />
                                {feature}
                            </li>
                        ))}
                    </ul>
                </div>

                {error && (
                    <div className="trial-error">
                        <Error size={20} />
                        {error}
                    </div>
                )}

                <div className="trial-modal-actions">
                    <button 
                        className="start-trial-button" 
                        onClick={handleStartTrial}
                        disabled={loading}
                    >
                        {loading ? 'Starting trial...' : 'Start free trial'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StartTrialModal;

